import { render, staticRenderFns } from "./localuploadFolder.vue?vue&type=template&id=2be5266c&scoped=true"
import script from "./localuploadFolder.vue?vue&type=script&lang=js"
export * from "./localuploadFolder.vue?vue&type=script&lang=js"
import style0 from "./localuploadFolder.vue?vue&type=style&index=0&id=2be5266c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be5266c",
  null
  
)

export default component.exports